import {
  ICreateApiTokenRequest,
  ICreateApiTokenResponse,
  IGetApiRequestLogsResponse,
  IGetApiTokensResponse,
} from 'shared';

import { orgHeader } from '../../../../common/lib/axiosBaseQuery';
import { emptySplitApi } from '../baseApi';
import { CacheTags } from '../../types/cacheTags';

export const apiTokenApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    fetchApiTokens: builder.query<IGetApiTokensResponse, string>({
      query: organisationId => ({
        url: `api-tokens`,
        method: `GET`,
        headers: {
          [orgHeader]: organisationId,
        },
      }),
      providesTags: [
        { type: CacheTags.ApiTokens, id: `LIST` },
      ],
    }),
    fetchApiRequestLogs: builder.infiniteQuery<
      IGetApiRequestLogsResponse,
      { organisationId: string; tokenId?: string; outcome?: `success` | `error` },
      string | undefined
    >({
      infiniteQueryOptions: {
        initialPageParam: undefined,
        getNextPageParam: lastPage => lastPage.nextCursor ?? undefined,
      },
      query: ({ queryArg: { organisationId, tokenId, outcome }, pageParam }) => ({
        url: `api-tokens/requests`,
        method: `GET`,
        headers: {
          [orgHeader]: organisationId,
        },
        params: {
          tokenId,
          outcome,
          cursor: pageParam,
        },
      }),
    }),
    createApiToken: builder.mutation<ICreateApiTokenResponse, { organisationId: string } & ICreateApiTokenRequest>({
      query: ({ organisationId, scopes }) => ({
        url: `api-tokens`,
        method: `POST`,
        headers: {
          [orgHeader]: organisationId,
        },
        data: {
          scopes,
        },
      }),
      invalidatesTags: [
        { type: CacheTags.ApiTokens, id: `LIST` },
      ],
    }),
    revokeApiToken: builder.mutation<void, { organisationId: string; tokenId: string }>({
      query: ({ organisationId, tokenId }) => ({
        url: `api-tokens/${tokenId}`,
        method: `DELETE`,
        headers: {
          [orgHeader]: organisationId,
        },
      }),
      invalidatesTags: [
        { type: CacheTags.ApiTokens, id: `LIST` },
      ],
    }),
  }),
});

export const {
  useFetchApiTokensQuery,
  useFetchApiRequestLogsInfiniteQuery,
  useCreateApiTokenMutation,
  useRevokeApiTokenMutation,
} = apiTokenApi;
